<template>
    <v-container>
        <div class="container-fluid">
            <h3>Graduate Tao Ying</h3>
            <div class="row" style="height: 100px;width:100%">
                <v-combobox v-model="data_taoying" multiple chips small-chips label="Graduate Tao Ying"
                    prepend-icon="mdi-account-multiple" readonly color="#F9A825" disabled style="max-width: 75%">
                </v-combobox>
                <v-btn style="margin-left:20px;margin-right:10px" color="#FCC133" dark @click="onSubmit">Graduate
                </v-btn>
                <v-btn style="margin-left:20px" color="#E12B38" dark @click="onClose">Cancel</v-btn>
            </div>
            <div>
                <v-data-table v-model="dataTables" item-key="ID_TRX" :headers="headers" class="elevation-1" show-select
                    :single-select="singleSelect" :items="inqTaoyu" :search="search" @item-selected="addDataGraduate"
                    @toggle-select-all="selectAllGraduate">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Tao Yu Data"
                                single-line hide-details color="#F9A825"></v-text-field>
                        </v-toolbar>
                    </template>
                </v-data-table>
            </div>
        </div>
        <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">Pilih Kota & Tempat Pelantikan</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-select :items="listKotaDaftar" label="Kota Pelantikan 就职城市" required
                                    v-model="kota_pelantikan" item-text="DESKRIPSI_DATA" item-value="ID_DATA">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-menu v-model="menu4" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="data_tgl_pelantikan" label="Tanggal Pelantikan 就职日期"
                                            prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"
                                            @blur="data_tgl_pelantikan_raw = parseDate(data_tgl_pelantikan)">
                                        </v-text-field>
                                    </template>
                                    <v-date-picker v-model="data_tgl_pelantikan_raw" @input="menu4 = false">
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                        Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="graduateTao()">
                        Graduate
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script type="text/javascript">
import axios from '@/axios'    
import 'fix-date' 
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/src/sweetalert2.scss'
export default {
    data: () => ({
        data_taoying:[],
        dataTables:[],
        inqTaoyu:[],
        singleSelect: false,
        listKotaDaftar: [],
        dialog:false,
        search: '',
        menu4:false,
        data_tgl_pelantikan: '',
        kota_pelantikan:'',
        data_tgl_pelantikan_raw: new Date().toISOString().substr(0, 10),
        headers: [
        { text: 'Nama', align: 'start',value: 'NAMA_INDO',},
        { text: 'Chinese Name (Pinyin)', value: 'NAMA_PINYIN' },
        { text: 'Chinese Name (Hanzi)', value: 'NAMA_HANZI' },
        { text: 'Updated By', value: 'NO_TAOYU', filterable: false },
        ],
        // menu: false, 
    }),
    props: {
        dataTaoyu: Object
    },
    watch: {
        data_tgl_pelantikan_raw(val) {
            this.data_tgl_pelantikan = this.formatDate(this.data_tgl_pelantikan_raw)
            // new Date(this.search_tgl_daftar_raw).toLocaleDateString('es-CL')
        },
    },
    mounted: function () {
        axios({
            method: 'post',
            url: 'master_data_by_admin',
            headers: {
                Authorization: 'Bearer ' + this.$session.get('token'),
            },
            data: {
                user_id: this.$session.get('user_id')
            }
        }).then(response => {
            this.listKotaDaftar = response.data.Kota_Daftar;
            // this.users=response.data;
            //Jika Edited
        }).catch(error => {
            console.log(error)
            // alert('Failed to retireve data !');
            // this.$emit('onCloseDialog');
            // var status = error.response.status
        });
        if(this.dataTaoyu){
            this.inqTaoyu=this.dataTaoyu.users;
        }
    },
    methods:{
        onClose(){
            this.data_taoying=[];
            this.dataTables=[];
            this.$emit('onCloseDialog');
        },
        parseDate(val) {
            if (val !== null && typeof (val) !== 'undefined') {
                return new Date(val).toISOString().substr(0, 10)
            } else {
                return null
            }

        },
        onSubmit(){
            confirm('Are you sure to process these data ?')
            this.dialog = true;
            // axios({
            //     method: 'post',
            //     url: 'daftar_huangyi',
            //     data: {
            //       id: dataID,
            //       user_id: this.$session.get('user_id')
            //     },
            //     headers: {
            //       'Authorization': 'Bearer ' + this.$session.get('token'),
            //     },
            // }).then(response => {
            //      Swal.fire({
            //                     title:'Peringatan',
            //                     icon :'success',
            //                     text:response.data
            //             });
            //     this.$emit('onCloseDialog');
            // }).catch(error=>{
            //     console.log('Error Fetch Data '+error);
            // });


        },
        graduateTao() {
            let dataID = this.dataTables.map(data => data.ID_TRX);
            console.log(dataID);
            axios({
                method: 'post',
                url: 'daftar_huangyi',
                data: {
                  id: dataID,
                  user_id: this.$session.get('user_id'),
                  tgl_pelantikan: this.data_tgl_pelantikan_raw,
                  kota_pelantikan: this.kota_pelantikan
                },
                headers: {
                  'Authorization': 'Bearer ' + this.$session.get('token'),
                },
            }).then(response => {
                 Swal.fire({
                                title:'Peringatan',
                                icon :'success',
                                text:response.data
                 });
                this.data_tgl_pelantikan= '';
                this.kota_pelantikan= '';
                this.$emit('onCloseDialog');
            }).catch(error=>{
                console.log('Error Fetch Data '+error);
            });
        },
        formatDate(val) {
            if (!val) {
                return null
            } else {
                return new Date(val).toLocaleDateString('es-CL');

            }
        },
        addDataGraduate(data){
            let index=this.data_taoying.indexOf(data.item.NAMA_INDO);
            if(index>=0){
                this.data_taoying.splice(index, 1);
            }else if(index==-1){
                this.data_taoying.push(data.item.NAMA_INDO);

            }
        },
        selectAllGraduate(data){
            let listName=this.dataTables.map(data => data.NAMA_INDO);
            let index;
            console.log(JSON.stringify(data));
            for(let i=0; i<data.items.length;i++){
                index=this.data_taoying.indexOf(data.items[i].NAMA_INDO);
                if(index>=0 && !data.value){
                    this.data_taoying.splice(index, 1);
                }else if(index==-1){
                    this.data_taoying.push(data.items[i].NAMA_INDO);

                }
            }
        }
    }
}
</script>